import React from "react";
import GoogleLogin from "react-google-login";
import { IoLogoGoogle } from "react-icons/io5";

export default function LoginButton({ res }) {
  return (
    <div>
      <GoogleLogin
        clientId="317707044722-vani72tg5vh7qm95m87sm2p9749b2lu8.apps.googleusercontent.com"
        render={(renderProps) => (
          <button
            onClick={renderProps.onClick}
            disabled={renderProps.disabled}
            className="login-btn gradient-anim"
          >
            <IoLogoGoogle size={22} />&nbsp;
            <span>Login with Google</span>
          </button>
        )}
        buttonText="Login"
        onSuccess={res}
        onFailure={res}
        cookiePolicy={"single_host_origin"}
      />
    </div>
  );
}
